import { getBanners } from '../../../data/repositories/businessRepository.js';

/**
 * Fetch active banners for a business
 * @param {string} businessId - The business ID
 * @returns {Promise<Array>} List of active banners with images, title, description, etc.
 */
export const fetchBanners = async (businessId) => {
  if (!businessId) return [];
  const response = await getBanners(businessId);
  return Array.isArray(response) ? response : response.data || [];
};
